import React, { useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import {
  Avatar,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";
import {
  Field,
  FieldArrayRenderProps,
  FormRenderProps,
} from "@progress/kendo-react-form";
import {
  CustomAppDialog,
  CustomDialogCloseButton,
} from "../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { MdDelete, MdOutlineImageNotSupported } from "react-icons/md";
import IconButton from "../../components/common/IconButton";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { IItem } from "../item/itemModel";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import {
  closePartAddtoOrdersOrderItemDeleteConfirmDialog,
  openPartAddtoOrdersOrderItemDeleteConfirmDialog,
  setPartAddtoOrdersOrderItemIndex,
} from "./partAddtoOrdersSlice";
import { findAllActiveItem } from "../item/services/item.services";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import {
  GridCellProps,
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
  GridPageChangeEvent,
  GridCustomFilterCellProps,
} from "@progress/kendo-react-grid";
import { FaRegEye } from "react-icons/fa";
import { findAllOrderLabelandPurchaseData } from "../order/services/order.services";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import CommonFilterCell from "../../components/common/GlobalCommonFilterCell";
import { clearFilterOrder, setFilterOrder } from "../order/orderSlice";
import { LoadingPanel } from "../../components/layout/Loading";
import { ImCross } from "react-icons/im";

const PartAddtoOrdersOrderItemArray = (
  fieldArrayRenderProps: FieldArrayRenderProps,
) => {
  const dispatch = useAppDispatch();
  const PartAddtoOrdersOrderItemIndex = useAppSelector(
    (state) => state.partAddtoOrders.PartAddtoOrdersOrderItemIndex,
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const isViewDialog = dialogName.startsWith("view-order-items-");
  const PartAddtoOrdersOrderItemDeleteConfirmDialog = useAppSelector(
    (state) =>
      state.partAddtoOrders.PartAddtoOrdersOrderItemDeleteConfirmDialog,
  );
  const fieldName = fieldArrayRenderProps.name;
  const ItemList = useAppSelector((state) => state.item.ItemList);

  const calculateTotal = (grossWeight: number, rate: number) => {
    return (grossWeight || 0) * (rate || 0);
  };

  const handleDeleteAction = React.useCallback(
    async (index: any) => {
      if (fieldArrayRenderProps?.value[index]?.ID) {
        // API delete call if needed
        fieldArrayRenderProps.onRemove({ index: index });
        dispatch(closePartAddtoOrdersOrderItemDeleteConfirmDialog());
        dispatch(setPartAddtoOrdersOrderItemIndex(-1));
      } else {
        fieldArrayRenderProps.onRemove({ index: index });
        dispatch(closePartAddtoOrdersOrderItemDeleteConfirmDialog());
        dispatch(setPartAddtoOrdersOrderItemIndex(-1));
      }
    },
    [fieldArrayRenderProps, dispatch],
  );

  //   const pushElementInarray = React.useCallback(() => {
  //     fieldArrayRenderProps?.onPush({
  //       value: {
  //         item_id: null,
  //         GrossWeight: null,
  //         NetWeight: null,
  //         Rate: null,
  //         Total: null,
  //       },
  //     });
  //   }, [fieldArrayRenderProps]);

  const handleOpenDeleteDialog = (index: any) => {
    dispatch(openPartAddtoOrdersOrderItemDeleteConfirmDialog());
    dispatch(setPartAddtoOrdersOrderItemIndex(index));
  };

  const handleSelectOrder = () => {
    dispatch(openDialog("addpartorderorderselectiondialog"));
  };

  return (
    <>
      <SelectOrderDialog fieldArrayRenderProps={fieldArrayRenderProps} />
      <CustomAppDialog open={PartAddtoOrdersOrderItemDeleteConfirmDialog}>
        <>
          <Typography.h5>{"Delete Order Item"}</Typography.h5>
          <GridLayout>
            <GridLayoutItem>
              <Typography.p>
                Are you sure you want to delete this order item?
              </Typography.p>
            </GridLayoutItem>
            <GridLayoutItem
              style={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              <CustomDialogCloseButton
                themeColor="error"
                closeDialogFunction={
                  closePartAddtoOrdersOrderItemDeleteConfirmDialog
                }
              />
              <Button
                fillMode={"solid"}
                themeColor={"error"}
                onClick={() =>
                  handleDeleteAction(PartAddtoOrdersOrderItemIndex)
                }
                type="button"
              >
                Delete
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </>
      </CustomAppDialog>

      <GridLayout cols={[{ width: "50%" }, { width: "50%" }]}>
        <GridLayoutItem
          style={{ display: "flex", alignItems: "center", gap: 10 }}
        >
          <Typography.h5 style={{ marginBottom: 5 }}>
            Order Items Detail
          </Typography.h5>
          {/* <Button
            type="button"
            fillMode={"solid"}
            themeColor={"primary"}
            style={{
              width: "fit-content",
            }}
            onClick={() => handleSelectOrder()}
          >
            Select Order
          </Button> */}
        </GridLayoutItem>
        <GridLayoutItem style={{ textAlign: "left", marginLeft: "auto" }}>
          <Button
            type="button"
            fillMode={"solid"}
            themeColor={"primary"}
            style={{
              width: "fit-content",
            }}
            onClick={() => handleSelectOrder()}
          >
            Select Order
          </Button>
          {/* {!isViewDialog && (
            <Button
              fillMode={"solid"}
              themeColor={"primary"}
              onClick={pushElementInarray}
              type="button"
            >
              Add Order Item
            </Button>
          )} */}
        </GridLayoutItem>
      </GridLayout>

      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.length > 0 && (
          <div
            className="table-responsive"
            style={{
              maxHeight: isViewDialog ? "50vh" : "30vh",
              scrollbarWidth: "thin",
              marginTop: 10,
            }}
          >
            <table
              className="table table-striped table-bordered table-hover field-array-table"
              style={{ minWidth: "100%" }}
            >
              <thead>
                <tr>
                  <th style={{ width: "25%" }}>Product Name</th>
                  <th style={{ width: "15%" }}>Gross Weight (gm)</th>
                  <th style={{ width: "15%" }}>Net Weight (gm)</th>
                  <th style={{ width: "15%" }}>Rate (₹)</th>
                  <th style={{ width: "15%" }}>Total (₹)</th>
                  <th style={{ width: "5%", position: "sticky" }}></th>
                </tr>
              </thead>
              <tbody>
                {fieldArrayRenderProps.value &&
                  fieldArrayRenderProps.value.length > 0 &&
                  fieldArrayRenderProps.value.map(
                    (orderItem: any, index: number) => (
                      <tr key={index}>
                        <td>
                          <Field
                            wrapperStyle={{ margin: 0 }}
                            name={`${fieldName}.${index}.item_id`}
                            placeholder="Select Item"
                            isAddNew={true}
                            disabled={true}
                            addNewLink="item/create"
                            dispatcherFunction={findAllActiveItem}
                            component={FormSelectionField}
                            validator={requiredValidator}
                            options={ItemList?.map((item: IItem) => {
                              return {
                                value: item.id,
                                label: item.item_name,
                              };
                            })}
                          />
                        </td>
                        <td>
                          <Field
                            wrapperStyle={{ margin: 0 }}
                            name={`${fieldName}.${index}.GrossWeight`}
                            placeholder="0.000"
                            format="n3"
                            type="number"
                            component={FormNumericTextField}
                            validator={requiredValidator}
                            disabled={isViewDialog}
                            onChange={(e: any) => {
                              const grossWeight = e.value;
                              const rate =
                                fieldArrayRenderProps.formRenderProps.valueGetter(
                                  `${fieldName}.${index}.Rate`,
                                );
                              const total = calculateTotal(grossWeight, rate);
                              fieldArrayRenderProps.formRenderProps.onChange(
                                `${fieldName}.${index}.Total`,
                                { value: total },
                              );
                            }}
                          />
                        </td>
                        <td>
                          <Field
                            wrapperStyle={{ margin: 0 }}
                            name={`${fieldName}.${index}.NetWeight`}
                            placeholder="0.000"
                            type="number"
                            format="n3"
                            component={FormNumericTextField}
                            validator={requiredValidator}
                            disabled={isViewDialog}
                          />
                        </td>
                        <td>
                          <Field
                            wrapperStyle={{ margin: 0 }}
                            name={`${fieldName}.${index}.Rate`}
                            placeholder="0.00"
                            type="number"
                            format="n2"
                            component={FormNumericTextField}
                            validator={requiredValidator}
                            disabled={isViewDialog}
                            onChange={(e: any) => {
                              const rate = e.value;
                              const grossWeight =
                                fieldArrayRenderProps.formRenderProps.valueGetter(
                                  `${fieldName}.${index}.GrossWeight`,
                                );
                              const total = calculateTotal(grossWeight, rate);
                              fieldArrayRenderProps.formRenderProps.onChange(
                                `${fieldName}.${index}.Total`,
                                { value: total },
                              );
                            }}
                          />
                        </td>
                        <td>
                          <Field
                            wrapperStyle={{ margin: 0 }}
                            name={`${fieldName}.${index}.Total`}
                            placeholder="0.00"
                            type="number"
                            format="n2"
                            component={FormNumericTextField}
                            disabled={true}
                          />
                        </td>
                        <td
                          style={{
                            position: "sticky",
                            right: 0,
                            zIndex: 2,
                          }}
                        >
                          <IconButton
                            type="button"
                            fillMode="solid"
                            size="small"
                            title="Delete"
                            themeColor="error"
                            style={{
                              position: "absolute",
                              height: 32,
                              width: 32,
                              right: 15,
                              pointerEvents: "all",
                            }}
                            onClick={() => handleOpenDeleteDialog(index)}
                          >
                            <MdDelete
                              className="absolute-position"
                              style={{ fontSize: "22px" }}
                            />
                          </IconButton>
                        </td>
                      </tr>
                    ),
                  )}
              </tbody>
            </table>
          </div>
        )}
    </>
  );
};

export default PartAddtoOrdersOrderItemArray;

interface SelectDialogProps {
  fieldArrayRenderProps: FieldArrayRenderProps;
  handlefetchWeight?: (
    previous_process_id: number,
    order_id: number,
    formRenderProps: FormRenderProps,
  ) => void;
}

const SelectOrderDialog = ({ fieldArrayRenderProps }: SelectDialogProps) => {
  const formRenderProps = fieldArrayRenderProps.formRenderProps;
  const orderList = useAppSelector((state) => state.order.finishedOrderList);

  const dispatch = useAppDispatch();

  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const loading = useAppSelector((state) => state.order.loading);
  const gridRef = useRef<any>(null);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const MyImageCommandCell = (props: GridCellProps) => {
    const handlClickItem = (image: string) => {
      if (image && typeof image === "string") {
        window.open(image);
      }
    };
    if (props.dataItem?.image === null) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "50px",
          }}
        >
          <MdOutlineImageNotSupported style={{ fontSize: "30px" }} />
          <p style={{ margin: 0, fontSize: "12px" }}>No Image!</p>
        </div>
      );
    }

    return (
      <td className="action-td main-image">
        <div
          style={{
            position: "relative",
            // border: "1px dotted lightgrey",
            // borderRadius: "5px",
            // height: "50px",
            // overflow: "hidden",
          }}
        >
          <Avatar
            className="select-order-avatar"
            style={{
              width: "50px",
              height: "50px",
              backgroundColor: props.dataItem?.image_name
                ? "transparent"
                : "#303F9F",
            }}
          >
            {props.dataItem?.image_name ? (
              <img
                src={props.dataItem?.image_name}
                alt={`No Image`}
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            ) : (
              `No Image`
            )}
          </Avatar>
          <div className="image-view">
            <FaRegEye
              style={{
                color: "white",
                height: 24,
                width: 24,
                cursor: "pointer",
              }}
              onClick={() => handlClickItem(props.dataItem?.image_name)}
            />
          </div>
        </div>
      </td>
    );
  };

  const MyEditCommandCell = (props: any) => {
    const handleSelectOrder = (order: any) => {
      const getOrderNowiseData = async () => {
        const updateField = (field: any, value: any) =>
          formRenderProps?.onChange(`${field}`, {
            value,
          });

        if (
          !(order.order_no || order.PurchaseID) ||
          formRenderProps.modified !== true
        ) {
          updateField("item_id", null);
          updateField("GrossWeight", null);
          updateField("NetWeight", null);
          updateField("Rate", null);
          updateField("Total", null);
          return;
        }

        try {
          // const { payload: res, meta } = await dispatch(
          //   findbyOrderNo({ order_no, process_id: 0 }),
          // );
          // if (meta.requestStatus === "fulfilled" && res) {
          fieldArrayRenderProps?.onPush({
            value: {
              item_id: order?.item_id ? order?.item_id : order?.ProductID,
              GrossWeight: order?.GrossWeight,
              NetWeight: order?.NetWeight,
              Rate: null,
              Total: null,
            },
          });
          // } else {
          //   updateField("item_id", null);
          //   updateField("GrossWeight", null);
          //   updateField("NetWeight", null);
          //   updateField("Rate", null);
          //   updateField("Total", null);
          // }
        } catch (error) {
          console.error(error);
        }
      };
      getOrderNowiseData();
      dispatch(closeDialog());
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        <Button
          type="button"
          fillMode="solid"
          themeColor={"primary"}
          size="small"
          title="Select Order"
          onClick={() => handleSelectOrder(props.dataItem)}
        >
          Select
        </Button>
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 7 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const OrderFilterCell = React.useCallback(
    (props: GridCustomFilterCellProps) => (
      <CommonFilterCell
        {...props}
        filterSelector={(state) => state.order.FilterOrder}
        setFilterAction={setFilterOrder}
        clearFilterAction={clearFilterOrder}
        fetchDataAction={findAllOrderLabelandPurchaseData}
        pagination={{ case: "lowercase" }}
      />
    ),
    [],
  );
  return (
    <>
      <CustomAppDialog open={dialogName === "addpartorderorderselectiondialog"}>
        <div style={{ width: "60vw", overflow: "hidden" }}>
          {loading && <LoadingPanel gridRef={gridRef} />}
          <GridLayout
            // style={{
            //   marginLeft: 30,
            // }}
            gap={{ rows: 10, cols: 10 }}
          >
            <GridLayoutItem
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography.h4 style={{ margin: 0 }}>
                {"Select Order"}
              </Typography.h4>

              <ImCross
                style={{
                  color: "white",
                  background: "red",
                  borderRadius: "50%",
                  padding: "5px",
                  fontSize: "24px",
                }}
                onClick={() => {
                  dispatch(closeDialog());
                  dispatch(clearFilterOrder());
                }}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "60vw" }}>
              <KendoGrid
                className="selection-dialog responsive-table"
                style={{ maxHeight: "calc(100vh - 152px)" }}
                filterable={true}
                filter={filter}
                data={filter ? filterBy(orderList, filter) : orderList}
                total={orderList[0]?.itemcount || orderList.length}
                onFilterChange={handleFilterChange}
                skip={currentPage * pageLimit}
                take={pageLimit}
                pageable={{
                  buttonCount: 5,
                  pageSizes: [10, 50, 100, 300, 500],
                  pageSizeValue: pageLimit,
                  type: "input",
                }}
                onPageChange={pageChange}
                cells={{
                  headerCell: HeaderCustomCell,
                  data: MyDataCustomCell,
                }}
              >
                <Column
                  field="image_name"
                  title="Image"
                  width={100}
                  cells={{
                    data: MyImageCommandCell,
                  }}
                  filterable={false}
                />
                <Column
                  field="order_no"
                  title="Or. No"
                  width={60}
                  filterable={false}
                  cells={{
                    data: (props: any) => (
                      <td>
                        <div style={{ color: "green" }}>
                          <strong>
                            {props.dataItem?.order_no ||
                              props.dataItem?.PurchaseID}
                          </strong>
                        </div>
                      </td>
                    ),
                  }}
                />
                <Column
                  field="InvoiceNo"
                  title="Invoice No"
                  width={100}
                  filterable={false}
                  cells={{
                    data: (props: any) => (
                      <td>
                        <strong>{props.dataItem?.InvoiceNo}</strong>
                      </td>
                    ),
                  }}
                />
                <Column
                  field="party_name"
                  title="Party Name"
                  width={200}
                  cells={{
                    data: (props: any) => (
                      <td>
                        {props.dataItem?.party_name ||
                          props.dataItem?.Purchase_party_name}
                      </td>
                    ),
                    filterCell: OrderFilterCell,
                  }}
                />
                <Column
                  field="item_name"
                  title="Product Name"
                  width={200}
                  cells={{
                    data: (props: any) => (
                      <td>
                        {props.dataItem?.item_name ||
                          props.dataItem?.purchaseitem_name}
                      </td>
                    ),
                    filterCell: OrderFilterCell,
                  }}
                />
                <Column
                  field="order_date"
                  title="Order/Purchase Date"
                  width={160}
                  cells={{
                    data: (props: any) => (
                      <td>
                        {props.dataItem?.order_date ||
                          props.dataItem?.PurchaseDate}
                      </td>
                    ),
                    filterCell: OrderFilterCell,
                  }}
                />
                <Column
                  field="delivery_date"
                  title="Delivery Date"
                  width={130}
                  cells={{
                    data: (props: any) => (
                      <td>{props.dataItem?.delivery_date || ""}</td>
                    ),
                    filterCell: OrderFilterCell,
                  }}
                />
                <Column
                  field="order_no"
                  title="Actions"
                  cells={{ data: MyEditCommandCell }}
                  width={90}
                  filterable={false}
                  locked={true}
                />
              </KendoGrid>
            </GridLayoutItem>
          </GridLayout>
        </div>
      </CustomAppDialog>
    </>
  );
};
